<div class="bot-chat-container">
  <img class="bot-pic" src="{{botImage}}">
  <div class="text-container">
    <span class="bot-chat-title"[innerHtml]="botTitle"></span>
    <span class="bot-chat-message" [innerHtml]="botMessage"></span>
  </div>  
</div>
